import React, { useEffect, useRef, useState } from 'react'
import Preloader from '../components/Preloader'
import { Helmet } from 'react-helmet-async'
import Header from '../components/Header'
import ScrollReveal from '../components/ScrollReveal'
import styles from '../styles/autoslider.module.css'
import Footer from '../components/Footer'

const Index = () => {
    const sliderRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)
    const [startX, setStartX] = useState(0)
    const [scrollLeft, setScrollLeft] = useState(0)
    const [partnerIndex, setPartnerIndex] = useState(0)

    const slides = [
        {
            image: '/assets/main-bg.jpg',
            text: 'Elevate Your Business with VR Solutions',
            subtext: 'Bring our virtual reality designs into your space. Explore our virtual reality showroom from any device, anywhere in the world',
            button: 'get started with us',
            link: '/contactus'
        },
        // {
        //     image: '/assets/vrify-careflow.jpg',
        //     text: 'VRIFY CareFlow: Smart Queue Management System',
        //     button: 'connect with us',
        //     link: '/contactus'
        // },
        {
            image: '/assets/carousel2.jpeg',
            text: 'See more with our Virtual Tours',
            subtext: 'Explore immersive 360° virtual tours that help your brand engage audiences, showcase spaces, and simplify immersive storytelling.',
            button: 'connect with us',
            link: '/contactus'
        },
        {
            image: '/assets/carousel1.jpeg',
            text: 'Secure your Inside Perimeter',
            subtext: 'Outsmart cyber threats with Syteca that strengthen your defenses and validate your security posture.',
            button: 'get started with us',
            link: '/contactus'
        }
    ]

    const solutions = [
        {
            title: 'Virtual Reality',
            description: 'Immersive simulations for training, education, and entertainment.',
            media: '/assets/main-bg1.jpg',
            mediaType: 'image',
            link: '/contactus'
        },
        {
            title: 'Augmented Reality',
            description: 'Overlay digital information onto the real world to enhance engagement.',
            media: '/assets/vr-bg1.jpg',
            mediaType: 'image',
            link: '/contactus'
        },
        {
            title: 'Virtual Tours',
            description: '360-degree panoramic tours for real estate, tourism, and facilities.',
            media: '/assets/eastlegon360arielview.mp4',
            mediaType: 'video',
            link: '/contactus'
        },
        {
            title: 'Syteca Cybersecurity',
            description: 'Comprehensive cybersecurity solutions to protect your digital assets.',
            media: '/assets/sytecalogotransparent.webp',
            mediaType: 'image',
            link: 'https://www.syteca.com/en'
        }
    ]

    const servicesList = [
        {
            title: 'Virtual Reality Experience',
            description: 'Custom VR experiences for marketing, training, and interactive storytelling.',
            media: '/assets/newvrifylogo1.png',
            mediaType: 'image',
            link: '/virtual-reality'
        },
        {
            title: 'Augmented Reality Experience',
            description: 'Interactive AR applications for retail, education, and advertising.',
            media: '/assets/newvrifylogo2black.png',
            mediaType: 'image',
            link: '/augmented-reality'
        },
        {
            title: '360° Virtual Tours Experience',
            description: 'Professional 360-degree panoramic tours for properties, venues, and facilities with interactive hotspots and navigation.',
            media: '/assets/eastlegon360arielview.mp4',
            mediaType: 'video',
            link: '/virtual-tours'
        },
        {
            title: 'Web Development',
            description: 'Responsive and user-friendly websites tailored to your business needs.',
            media: '/assets/newvrifylogo2black.png',
            mediaType: 'image',
            link: '/web-development'
        }
    ]

    const partners = [
        { name: 'Partner 1', src: '/assets/pendulummedia.jpg', alt: 'Partner 1 Logo' },
        { name: 'Partner 2', src: '/assets/89devsblacklogo.jpg', alt: 'Partner 2 Logo' },
        { name: 'Partner 4', src: '/assets/Syteca-logo-color_small.png', alt: 'Partner 4 Logo' },
        { name: 'Partner 5', src: '/assets/VRIFY_Africa_full_logo[1].png', alt: 'Partner 5 Logo' },
        { name: 'Partner 6', src: '/assets/alltech-logo.png', alt: 'Partner 6 Logo' },
        { name: 'Partner 7', src: '/assets/pendulummedia.jpg', alt: 'Partner 7 Logo' },
        { name: 'Partner 8', src: '/assets/89devsblacklogo.jpg', alt: 'Partner 8 Logo' },
        { name: 'Partner 9', src: '/assets/Syteca-logo-color_small.png', alt: 'Partner 9 Logo' },
        { name: 'Partner 10', src: '/assets/VRIFY_Africa_full_logo[1].png', alt: 'Partner 10 Logo' },
        { name: 'Partner 11', src: '/assets/alltech-logo.png', alt: 'Partner 11 Logo' },
    ]

    // Separate clients array (used for the clients autoslide carousel)
    const clients = [
        { name: 'Client A', src: '/assets/mainlogotransparentbg.png', alt: 'Client A Logo' },
        { name: 'Client B', src: '/assets/images (9).jpeg', alt: 'Client B Logo' },
        { name: 'Client C', src: '/assets/images (8).jpeg', alt: 'Client C Logo' },
        { name: 'Client D', src: '/assets/mundiallogo-C0DBEURL.png', alt: 'Client D Logo' },
        { name: 'Client E', src: '/assets/icon-512x512.png', alt: 'Client E Logo' },
        { name: 'Client F', src: '/assets/themetrolenslogo-1.png', alt: 'Client F Logo' },
        { name: 'Client G', src: '/assets/arca_logo.e843a6e554e1bf4bb9a7.png', alt: 'Client G Logo' },
        { name: 'Client H', src: '/assets/flosam.jpg', alt: 'Client H Logo' },
        { name: 'Client I', src: '/assets/pent.png', alt: 'Client I Logo' },
        { name: 'Client J', src: '/assets/vert.png', alt: 'Client J Logo' },
    ]

    const industries = [
        {
            name: 'Real Estate',
            services: ['Virtual Property Tours', '3D Walkthroughs', 'AR Property Visualization', 'Interactive Floor Plans']
        },
        {
            name: 'Retail & E-commerce',
            services: ['Virtual Showrooms', 'AR Try-On', 'Interactive Product Displays', 'Virtual Store Experience']
        },
        {
            name: 'Education',
            services: ['Immersive Learning', 'Virtual Classrooms', 'Interactive Training', 'VR Simulations']
        },
        {
            name: 'Healthcare',
            services: ['Medical Training VR', 'Patient Education', 'Surgical Simulations', 'Therapy Applications']
        },
        {
            name: 'Tourism & Hospitality',
            services: ['Destination Marketing', 'Hotel Room Tours', 'Experience Preview', 'Booking Enhancement']
        },
        {
            name: 'Events & Entertainment',
            services: ['Virtual Events', 'Interactive Experiences', 'Live Streaming VR', 'Engagement Tools']
        },
        {
            name: 'Architecture & Design',
            services: ['Design Visualization', 'Client Presentations', 'Building Walkthroughs', 'AR Site Plans']
        }
    ]

    const [heroIndex, setHeroIndex] = useState(0)
    const [animateText, setAnimateText] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const carouselRef = useRef(null)
    const nextSectionRef = useRef(null)
    const [isCarouselVisible, setIsCarouselVisible] = useState(true)
    const [isAtTop, setIsAtTop] = useState(true)
    const [selectedIndustry, setSelectedIndustry] = useState(0)
    const [currentServicesPage, setCurrentServicesPage] = useState(1)

    const servicesPerPage = 4
    const totalServicePages = Math.max(1, Math.ceil(servicesList.length / servicesPerPage))
    const paginatedServices = servicesList.slice((currentServicesPage - 1) * servicesPerPage, currentServicesPage * servicesPerPage)

    useEffect(() => {
        const interval = window.setInterval(() => {
            setHeroIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1))
        }, 5000)

        return () => window.clearInterval(interval)
    }, [slides.length])

    useEffect(() => {
        setAnimateText(true)
        const timeout = window.setTimeout(() => setAnimateText(false), 1000)
        return () => window.clearTimeout(timeout)
    }, [heroIndex])

    useEffect(() => {
        const handleLoad = () => setIsLoading(false)
        if (document.readyState === 'complete') {
            handleLoad()
            return
        }

        window.addEventListener('load', handleLoad)
        return () => window.removeEventListener('load', handleLoad)
    }, [])

    useEffect(() => {
        const onScroll = () => setIsAtTop(window.scrollY === 0)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    useEffect(() => {
        if (!carouselRef.current) return

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => setIsCarouselVisible(entry.isIntersecting))
            },
            { threshold: 0.6 }
        )

        observer.observe(carouselRef.current)
        return () => observer.disconnect()
    }, [])

    const handleMenuToggle = (open) => setIsMenuOpen(open)

    const loopSlides = [...partners, ...partners, ...partners, ...partners, ...partners, ...partners]

    const handleMouseDown = (event) => {
        setIsDragging(true)
        setStartX(event.pageX - sliderRef.current.offsetLeft)
        setScrollLeft(sliderRef.current.scrollLeft)
    }

    const handleMouseLeave = () => setIsDragging(false)
    const handleMouseUp = () => setIsDragging(false)

    const handleMouseMove = (event) => {
        if (!isDragging) return
        event.preventDefault()
        const x = event.pageX - sliderRef.current.offsetLeft
        const walk = (x - startX) * 1.5
        sliderRef.current.scrollLeft = scrollLeft - walk
    }

    const handleTouchStart = (event) => {
        setIsDragging(true)
        setStartX(event.touches[0].pageX - sliderRef.current.offsetLeft)
        setScrollLeft(sliderRef.current.scrollLeft)
    }

    const handleTouchEnd = () => setIsDragging(false)

    const handleTouchMove = (event) => {
        if (!isDragging) return
        const x = event.touches[0].pageX - sliderRef.current.offsetLeft
        const walk = (x - startX) * 1.5
        sliderRef.current.scrollLeft = scrollLeft - walk
    }

    useEffect(() => {
        if (!sliderRef.current) return
        const slideWidth = 250 + 30
        sliderRef.current.scrollLeft = partners.length * slideWidth
    }, [partners.length])

    

    useEffect(() => {
        const slider = sliderRef.current
        if (!slider) return

        const slideWidth = 250 + 30
        const totalSlides = partners.length
        const totalLoopSlides = loopSlides.length

        const handleScroll = () => {
            const maxScroll = slideWidth * (totalLoopSlides - totalSlides)
            if (slider.scrollLeft <= 0) {
                slider.scrollLeft = slideWidth * totalSlides
            } else if (slider.scrollLeft >= maxScroll) {
                slider.scrollLeft = slideWidth * totalSlides
            }

            const idx = Math.round(slider.scrollLeft / slideWidth) % totalSlides
            setPartnerIndex(idx)
        }

        slider.addEventListener('scroll', handleScroll)
        return () => slider.removeEventListener('scroll', handleScroll)
    }, [loopSlides.length, partners.length])

    const scrollToSlide = (index) => {
        if (!sliderRef.current) return
        const slideWidth = 250 + 30
        sliderRef.current.scrollTo({
            left: (partners.length + index) * slideWidth,
            behavior: 'smooth'
        })
    }

    const goToPrev = () => {
        scrollToSlide((partnerIndex - 1 + partners.length) % partners.length)
    }

    const goToNext = () => {
        scrollToSlide((partnerIndex + 1) % partners.length)
    }

    // --- Clients autoslide carousel (below services) ---
    const clientsRef = useRef(null)
    const [clientsPaused, setClientsPaused] = useState(false)
    const clientsPausedRef = useRef(false)

    const clientsLoop = [...clients, ...clients, ...clients]

    useEffect(() => {
        const el = clientsRef.current
        if (!el) return

        // initial center
        const slide = el.querySelector('.' + styles.clientSlide)
        const slideWidth = (slide ? slide.offsetWidth : 200) + 18
        el.scrollLeft = clients.length * slideWidth

        let rafId
        const baseSpeed = 0.8 // slow base speed (pixels per frame) — increased for visibility
        let currentSpeed = baseSpeed

        const step = () => {
            const target = clientsPausedRef.current ? 0 : baseSpeed
            // ease currentSpeed toward target for smooth stop/start
            currentSpeed += (target - currentSpeed) * 0.08

            // very small threshold to avoid micro-movements when effectively zero
            const effectiveSpeed = Math.abs(currentSpeed) < 0.001 ? 0 : currentSpeed

            el.scrollLeft += effectiveSpeed

            const maxScroll = slideWidth * (clientsLoop.length - clients.length)
            if (el.scrollLeft >= maxScroll) {
                el.scrollLeft = slideWidth * clients.length
            }

            rafId = requestAnimationFrame(step)
        }

        rafId = requestAnimationFrame(step)
        return () => cancelAnimationFrame(rafId)
    }, [partners.length])

    return (
        <div className="min-h-screen bg-slate-950 text-slate-100">
            <Helmet>
                <title>VRIFY Technologies | VR, AR & Virtual Tours Solutions</title>
                <meta
                    name="description"
                    content="Immersive VR and AR solutions for businesses across Africa. Virtual reality tours, augmented reality experiences, and immersive engagement services."
                />
                <meta
                    name="keywords"
                    content="VR, AR, virtual tours in ghana, tourism in ghana, tourism in africa, tech, I.T, virtual reality, augmented reality, virtual tours, immersive technology, Africa"
                />
                <meta property="og:title" content="VRIFY Technologies | VR, AR & Virtual Tours" />
                <meta property="og:description" content="Leading provider of immersive VR and AR solutions for businesses across Africa." />
            </Helmet>

            <div className="relative z-30">
                <Header onMenuToggle={handleMenuToggle} />
            </div>

            <section
                ref={carouselRef}
                className="relative overflow-hidden"
            >
                <div className="absolute inset-0">
                    <img
                        src={slides[heroIndex].image}
                        alt="Featured VRIFY Technologies experience"
                        className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(15,23,42,0.88),rgba(15,23,42,0.58),rgba(15,23,42,0.82))]" />
                </div>

                <div className="relative z-10 mx-auto flex min-h-[100vh] max-w-7xl flex-col justify-center px-4 pb-12 pt-24 sm:px-6 sm:pt-28 lg:px-8 lg:pt-32">
                    {!isMenuOpen && (
                        <div className="max-w-3xl space-y-6">
                            <p className="inline-flex w-fit items-center gap-2 rounded-full border border-yellow-300/50 bg-yellow-300/10 px-4 py-1 text-[11px] font-bold uppercase tracking-[0.3em] text-yellow-200">
                                VRIFY technologies
                            </p>
                            <h1
                                className={`text-3xl font-bold leading-tight text-white transition-all duration-700 sm:text-4xl lg:text-5xl ${animateText ? 'scale-[1.01] text-yellow-200' : ''}`}
                            >
                                {slides[heroIndex].text}
                            </h1>
                            <h1 className="max-w-2xl text-sm leading-7 text-slate-200 sm:text-base">
                                {slides[heroIndex].subtext}
                            </h1>
                            {/* <p className="max-w-2xl text-sm leading-7 text-slate-200 sm:text-base">
                                Explore immersive virtual reality, augmented reality, and 360° virtual tours that help your brand engage audiences, showcase spaces, and simplify immersive storytelling.
                            </p> */}
                            <div className="flex flex-wrap gap-3">
                                <a
                                    href={slides[heroIndex].link}
                                    className="inline-flex capitalize items-center justify-center rounded-full bg-yellow-400 px-5 py-3 text-sm font-bold text-slate-950 transition hover:bg-yellow-300"
                                >
                                    {slides[heroIndex].button}
                                </a>
                                <button
                                    type="button"
                                    onClick={() => nextSectionRef.current?.scrollIntoView({ behavior: 'smooth' })}
                                    className="inline-flex items-center justify-center rounded-full border border-white/20 bg-white/5 px-5 py-3 text-sm font-semibold text-white backdrop-blur-sm transition hover:border-yellow-300 hover:text-yellow-200"
                                >
                                    Explore solutions
                                </button>
                            </div>
                            {/* 
                            <div className="flex flex-wrap gap-3 pt-2 text-sm text-slate-200">
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1">VR</span>
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1">AR</span>
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1">Virtual Tours</span>
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1">Cybersecurity</span>
                            </div> */}
                        </div>
                    )}

                    {!isMenuOpen && (
                        <div className="mt-10 flex items-center gap-2">
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    aria-label={`Show slide ${index + 1}`}
                                    onClick={() => setHeroIndex(index)}
                                    className={`h-2.5 rounded-full transition-all duration-300 ${heroIndex === index ? 'w-8 bg-yellow-300' : 'w-2.5 bg-white/60'}`}
                                />
                            ))}
                        </div>
                    )}
                </div>

                {isCarouselVisible && isAtTop && !isMenuOpen && (
                    <button
                        aria-label="Scroll to next"
                        onClick={() => nextSectionRef.current?.scrollIntoView({ behavior: 'smooth' })}
                        className="absolute bottom-6 left-1/2 z-40 -translate-x-1/2 rounded-full border border-white/20 bg-white/10 p-3 text-white backdrop-blur-md transition hover:scale-110 hover:bg-yellow-400/90"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                )}
            </section>

            {isLoading && (
                <div className="fixed inset-0 z-50">
                    <Preloader />
                </div>
            )}

            <div ref={nextSectionRef} className="bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <ScrollReveal>
                        <div className="text-center">
                            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-300">Our solutions</p>
                            <h2 className="mt-4 text-2xl font-bold text-white sm:text-3xl">Built for immersive experiences that drive engagement.</h2>
                            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
                                Discover how our cutting-edge solutions can transform your business and help you connect with audiences in memorable ways.
                            </p>
                        </div>
                    </ScrollReveal>

                    <div className="mt-8 grid gap-6 lg:grid-cols-4">
                        {solutions.map((solution, index) => (
                            <ScrollReveal key={solution.title}>
                                <article className="flex h-full flex-col overflow-hidden rounded-[24px] border border-white/10 bg-slate-900/80 shadow-[0_30px_80px_rgba(15,23,42,0.28)] transition duration-300 hover:-translate-y-1 hover:border-yellow-300/80">
                                    <div className="relative h-40 overflow-hidden">
                                        {solution.mediaType === 'video' ? (
                                            <video src={solution.media} autoPlay loop muted playsInline className="h-full w-full object-cover" />
                                        ) : (
                                            <img src={solution.media} alt={solution.title} className="h-full w-full object-cover" loading="lazy" />
                                        )}
                                        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/10 to-transparent" />
                                        <span className="absolute left-4 top-4 rounded-full bg-yellow-400 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-slate-950">
                                            {index + 1}
                                        </span>
                                    </div>
                                    <div className="flex flex-1 flex-col p-5">
                                        <h3 className="text-lg font-semibold text-white">{solution.title}</h3>
                                        <p className="mt-3 flex-1 text-sm leading-7 text-slate-300">{solution.description}</p>
                                        <a href={solution.link} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-yellow-300 transition hover:text-yellow-200">
                                            Get Started
                                            <span aria-hidden="true">→</span>
                                        </a>
                                    </div>
                                </article>
                            </ScrollReveal>
                        ))}
                    </div>
                </div>
            </div>

            <section className="bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <ScrollReveal>
                        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-300">Industries we empower</p>
                                <h2 className="mt-4 text-2xl font-bold text-white sm:text-3xl">Tailored immersive solutions for every sector.</h2>
                                <p className="mt-4 text-sm leading-7 text-slate-300 sm:text-base">
                                    From real estate and hospitality to education and events, we turn complex ideas into experiences that feel intuitive, memorable, and easy to adopt.
                                </p>
                                <div className="mt-6 space-y-3">
                                    {industries.map((industry, index) => (
                                        <button
                                            key={industry.name}
                                            type="button"
                                            onClick={() => setSelectedIndustry(index)}
                                            className={`w-full rounded-2xl px-4 py-4 text-left transition-all duration-300 ${selectedIndustry === index ? 'bg-yellow-400 text-slate-950 shadow-[0_16px_40px_rgba(250,204,21,0.28)]' : 'border border-white/10 bg-white/5 text-white hover:border-yellow-300/60'}`}
                                        >
                                            <div className="flex items-center justify-between gap-3">
                                                <span className="font-semibold">{industry.name}</span>
                                                {selectedIndustry === index && <span aria-hidden="true">✓</span>}
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="rounded-[28px] border border-white/10 bg-slate-900/85 p-6 shadow-[0_30px_80px_rgba(15,23,42,0.28)] sm:p-8">
                                <div className="flex items-center gap-3">
                                    <div className="rounded-2xl bg-yellow-400/15 p-3 text-yellow-300">
                                        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-300">Focused expertise</p>
                                        <h3 className="mt-1 text-xl font-bold text-white">{industries[selectedIndustry].name}</h3>
                                    </div>
                                </div>
                                <p className="mt-4 text-sm leading-7 text-slate-300">
                                    Discover how our immersive systems can revolutionize the {industries[selectedIndustry].name.toLowerCase()} industry through storytelling, training, and interactive customer experiences.
                                </p>
                                <div className="mt-6 grid gap-3 md:grid-cols-2">
                                    {industries[selectedIndustry].services.map((service) => (
                                        <div key={service} className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-slate-100">
                                            {service}
                                        </div>
                                    ))}
                                </div>
                                <div className="mt-6">
                                    <a href="/contactus" className="inline-flex items-center gap-2 rounded-full bg-yellow-400 px-5 py-3 text-sm font-bold text-slate-950 transition hover:bg-yellow-300">
                                        Get our {industries[selectedIndustry].name} solutions
                                        <span aria-hidden="true">→</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ScrollReveal>
                </div>
            </section>

            <section className="bg-slate-300">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <ScrollReveal>
                        <div className="text-center">
                            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-500">Our services</p>
                            <h2 className="mt-4 text-2xl font-bold text-slate-950 sm:text-3xl">Flexible services designed to scale with your goals.</h2>
                            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-600 sm:text-base">
                                Explore the core services we deliver for our clients across industries, teams, and digital channels.
                            </p>
                        </div>
                    </ScrollReveal>

                    <div className="mt-8 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
                        {paginatedServices.map((service) => (
                            <ScrollReveal key={service.title}>
                                <article className="flex h-full flex-col overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_20px_60px_rgba(15,23,42,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(15,23,42,0.14)]">
                                    <div className="h-40 overflow-hidden bg-slate-100">
                                        {service.mediaType === 'video' ? (
                                            <video src={service.media} autoPlay loop muted playsInline className="h-full w-full object-cover" />
                                        ) : (
                                            <img src={service.media} alt={service.title} className="h-full w-full object-cover" loading="lazy" />
                                        )}
                                    </div>
                                    <div className="flex flex-1 flex-col p-5">
                                        <h3 className="text-lg font-semibold text-slate-950">{service.title}</h3>
                                        <p className="mt-3 flex-1 text-sm leading-7 text-slate-600">{service.description}</p>
                                        <a href={service.link} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-yellow-500 transition hover:text-yellow-600">
                                            Learn More
                                            <span aria-hidden="true">→</span>
                                        </a>
                                    </div>
                                </article>
                            </ScrollReveal>
                        ))}
                    </div>

                    <div className="mt-8 flex flex-wrap items-center justify-center gap-3 text-sm">
                        <button
                            type="button"
                            onClick={() => setCurrentServicesPage((prev) => Math.max(1, prev - 1))}
                            disabled={currentServicesPage === 1}
                            className="rounded-full border border-slate-200 bg-white px-4 py-2 text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Previous
                        </button>

                        {Array.from({ length: totalServicePages }, (_, index) => index + 1).map((page) => (
                            <button
                                key={page}
                                type="button"
                                onClick={() => setCurrentServicesPage(page)}
                                className={`rounded-full px-4 py-2 ${currentServicesPage === page ? 'bg-yellow-400 text-slate-950' : 'border border-slate-200 bg-white text-slate-700'}`}
                            >
                                {page}
                            </button>
                        ))}

                        <button
                            type="button"
                            onClick={() => setCurrentServicesPage((prev) => Math.min(totalServicePages, prev + 1))}
                            disabled={currentServicesPage === totalServicePages}
                            className="rounded-full border border-slate-200 bg-white px-4 py-2 text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </section>

            {/* Clients autosliding carousel - placed below services */}
            <section className="bg-slate-300">
                <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-600">Our clients</p>
                        <h2 className="mt-4 text-2xl font-bold text-slate-900 sm:text-3xl lg:text-4xl">Trusted by our amazing clients.</h2>
                        <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-700 sm:text-base">We partner with amazing clients to deliver immersive experiences.</p>
                    </div>

                    <div className={`${styles.clientsWrapper} mt-8`}> 
                        <div
                            ref={clientsRef}
                            className={styles.clientsSlider}
                            onMouseEnter={() => { setClientsPaused(true); clientsPausedRef.current = true }}
                            onMouseLeave={() => { setClientsPaused(false); clientsPausedRef.current = false }}
                            onTouchStart={() => { setClientsPaused(true); clientsPausedRef.current = true }}
                            onTouchEnd={() => { setClientsPaused(false); clientsPausedRef.current = false }}
                        >
                            <div className={styles.clientsTrack} style={{ padding: '8px 12px' }}>
                                {clientsLoop.map((c, i) => (
                                    <div className={styles.clientSlide} key={`${c.src}-${i}`}>
                                        <img src={c.src} alt={c.alt} loading="lazy" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                className="relative overflow-hidden"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/vr-bg1.jpg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/60" />
                <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
                    <div className="max-w-3xl text-white">
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-300">Ready to transform?</p>
                        <h2 className="mt-4 text-2xl font-bold sm:text-3xl">Bring your next immersive idea to life with VRIFY Technologies</h2>
                        <p className="mt-4 text-sm leading-7 text-slate-200 sm:text-base">
                            Whether you want to elevate your brand, train your team, or give your audience an unforgettable experience, we help turn the concept into a polished, measurable outcome.
                        </p>
                        <div className="mt-8">
                            <a href="/contactus" className="inline-flex items-center gap-2 rounded-full bg-yellow-400 px-5 py-3 text-sm font-bold text-slate-950 transition hover:bg-yellow-300">
                                Get started with VRIFY
                                <span aria-hidden="true">→</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <ScrollReveal>
                        <div className="text-center">
                            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-yellow-300">Our partners</p>
                            <h2 className="mt-4 text-2xl font-bold text-white sm:text-3xl">Trusted by teams building standout experiences.</h2>
                            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
                                A closer look at the partners we work with across digital and creative projects.
                            </p>
                        </div>
                    </ScrollReveal>

                    <div className="mt-6 rounded-[28px] border border-white/10 bg-white/5 p-4 sm:p-5">
                        <div className="relative">
                            <div
                                ref={sliderRef}
                                onMouseDown={handleMouseDown}
                                onMouseLeave={handleMouseLeave}
                                onMouseUp={handleMouseUp}
                                onMouseMove={handleMouseMove}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                                onTouchMove={handleTouchMove}
                                className={styles.firstsliding}
                                style={{ cursor: isDragging ? 'grabbing' : 'grab', position: 'relative' }}
                                tabIndex={0}
                            >
                                <div className={styles.firstslidetrack} style={{ width: `calc(250px * ${loopSlides.length})` }}>
                                    {loopSlides.map((slide, index) => (
                                        <div className={styles.firstslide} key={`${slide.src}-${index}`}>
                                            <img src={slide.src} alt={slide.alt} loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
                                <p className="text-sm text-slate-300">Partner spotlight {partnerIndex + 1} of {partners.length}</p>
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        onClick={goToPrev}
                                        aria-label="Previous partner"
                                        className="rounded-full border border-white/10 px-4 py-2 text-sm text-white transition hover:border-yellow-300 hover:text-yellow-200"
                                    >
                                        Prev
                                    </button>
                                    <button
                                        type="button"
                                        onClick={goToNext}
                                        aria-label="Next partner"
                                        className="rounded-full bg-yellow-400 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-yellow-300"
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    )
}

export default Index